module.exports = __webpack_public_path__ + "img/07.be215bf3.png";